<template>
  <div v-html="renderedMarkdown"></div>
</template>

<script>
import markdownIt from 'markdown-it';

export default {
  name: 'MarkdownViewer',
  props: {
    content: {
      type: String,
      required: true
    }
  },
  computed: {
    renderedMarkdown() {
      const md = new markdownIt();
      return md.render(this.content);
    }
  }
};
</script>

<style scoped>
/* 这里您可以根据需要添加Markdown的样式 */
</style>
